import { useCart } from '../../context/CartProvider';
import ImageWithFallback from '../ui/ImageWithFallback';

const {
    labelCart,
    labelOrderNow,
    lang_edit_item,
    lang_remove_item,
    template_directory_uri
} = window.ordering_cart_script_checkout;

const InfoDrawer = () => {
    const { patientResources, numberOfItems, editItem, remove, gotToCheckoutByOrderNow } = useCart()
    return (
        <div className="offcanvas offcanvas-end" id="organonOrderingCartOffcanvasReact">
            <div className="offcanvas-header" style={{ padding: '2.4rem 2.9rem 0.4rem' }}>
                <h3 className="offcanvas-title">{labelCart} ({numberOfItems})</h3> &nbsp;
                <button type="button" className="btn-close" data-bs-dismiss="offcanvas" id="closeButtonreachlimitCartForm"></button>
            </div>
            <div className="offcanvas-body">
                {
                    patientResources?.length > 0 && patientResources.map((patientResource, index) => {
                        return <div className="cart-item-card" key={index}>
                            <div className="cart-item-card-body">
                                <div className="row no-gutters">
                                    <div className="col-3 mycart-items">
                                        <div className="no-gutters">
                                            <div className="cart-item-card-body-img-div mycart-body-view-img col-12">
                                                {patientResource?.material_image ? <ImageWithFallback className={'cart-item-card-body-img'} src={patientResource?.material_image} fallback={`${template_directory_uri}/assets/images/no_preview.png`} alt={patientResource?.post_title}  /> : <ImageWithFallback className={'cart-item-card-body-img'} src={`${template_directory_uri}/assets/images/no_preview.png`} alt={patientResource?.post_title} />}
                                                
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-9 nopadding">
                                        <div className="no-gutters">
                                            <div className="col-12">
                                                <p className="h5Cart">{patientResource?.post_title}</p>
                                                <p className="cart-item-card-quantity">x{patientResource?.order_quantity}</p>
                                            </div>
                                        </div>
                                        <div className="no-gutters">
                                            <div className="col-12">
                                                {(patientResource?.order_size && patientResource?.order_variant) && <p className="pCart">{patientResource.order_variant}, {patientResource?.order_size}</p>}
                                                {(patientResource?.order_variant && !patientResource?.order_size) && <p className="pCart">{patientResource?.order_variant}</p>}
                                                {(!patientResource?.order_variant && patientResource?.order_size) && <p className="pCart">{patientResource?.order_size}</p>}
                                            </div>
                                        </div>
                                        <div className="no-gutters">
                                            <div className="col-12">
                                                <a className="aCart" href="javascript:void(0);" onClick={() => editItem(patientResource)} data-bs-toggle="offcanvas" data-bs-target="#orderingCartEditItemDivReact">{lang_edit_item}</a>
                                                <a className="aCartRemove" onClick={() => remove(patientResource.ID)} href="#">{lang_remove_item}</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    })
                }
            </div>
            <div className="ordering-cart-order-now-div">
                <button disabled={numberOfItems <= 0} className="btn btn-theme ordering-cart-order-now-btn" type="button" id="orderingNowBtn" onClick={gotToCheckoutByOrderNow}>
                    {labelOrderNow}
                </button>
            </div>
        </div>
    )
}

export default InfoDrawer